const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);

// Install the global axios success/error → toast bridge for every page.
require('utils/axios_setup');

require('players/roster');
require('players/game_events');
require('coaches/roster');

require("trix")
require("@rails/actiontext")
require("fix_lightgallery_allow")